module.exports = {
  game: 'Game',
  gameNameTranslations: {
    'bingo75': 'Bingo75',
    'classic': 'Klassisk',
    'egyptian': 'Egyptisk',
    'suits': 'Svit',
    'deep': 'Havsdjupet',
    'sacred': 'Heliga Stenen',
    'goldrush': 'Guldrush',
    'galleon': 'Skeppet',
    'phoenix': 'Fenix',
    'cosmos': 'Kosmos',
    'carnival': 'Tivoli',
    'invasion': 'UFO',
    'vikings': 'Viking',
    'pirate': 'Piratens Förbannelse',
    'emoji': 'Emoji',
    'numbers': 'Nummer',
    'temple': 'Tempel',
    'parade': 'Parad',
    'wanted': 'Vilda Västern',
    'wildwood': 'Förtrollad'
  },
  prize: {
    currencySymbol: 'kr',
    currencySymbolForPennies: 'kr'
  },
  jackpot: {
    won: 'JACKPOT WON',
    notWon: 'No jackpot winners this game',
    title: 'Jackpot'
  },
  winners: {
    gameWinnersModalTitle: 'Winners',
    previousGameWinners: 'Past 10 Winners',
    previousJackpotWinners: 'Past 10 Jackpot Winners',
    previousBonusGameWinners: 'Past 10 Bonus Game Winners',
    previousHamsterRaceBigWinners: 'Past 10 Largest Winners',
    previous100GameWinners: 'Past 100 Winners',
    tableHeaders: {
      gameId: 'Game Id',
      stamp: 'Stamp',
      winners: 'Winners',
      room: 'Room'
    },
    winnerTemplate: '{username} - {prize}kr ',
    winnersWindow: {
      tableHeaders: {
        game: 'Game',
        username: 'Name',
        prize: 'Prize'
      },
      freeze: 'freeze',
      title: 'Game Winners',
      copy: 'Copy'
    },
    popup: {
      title: 'Winner!',
      message: '{username} has won {prize} in {gameName}',
      extendedMessage: '{username} has won {prize} in {gameName} ({prizeType})'
    }
  },
  hamsterRace: {
    lastEigthWinnersTitle: 'Last 8 Winners',
    firstPlace: '1st',
    hamster: 'Hamster',
    wins: 'Wins',
    winners: {
      tableHeaders: {
        winningHamster: 'Winning Hamster'
      }
    }
  },
  rollercoaster: {
    lastSixCallsTitle: 'Last 6 Calls'
  },
  arcade: {
    winners: {
      tableHeaders: {
        winnerName: 'Winner Name',
        gameName: 'Game Name',
        prize: 'Prize',
        stamp: 'Stamp'
      }
    },
    gameNameFormat: '{gameName}'
  },
  quizQuids: {
    tableHeaders: {
      winnerName: 'Winner Name',
      chatModeratorName: 'Chatmod Name',
      stamp: 'Stamp'
    }
  },
  pictureBingo: {
    winners: {
      tableHeaders: {
        theme: 'Theme'
      }
    }
  }
}



//////////////////
// WEBPACK FOOTER
// ./src/plugins/localisation/languages/se/game.js
// module id = OUSG
// module chunks = 1